import { useSearchParams, Link, useOutletContext } from "react-router-dom";
import { CheckCircle2, MessageCircle, Phone, MapPin } from "lucide-react";

export default function ThankYou() {
  const [params] = useSearchParams();
  const { settings } = useOutletContext();
  const ref = params.get("ref");
  const name = params.get("name");
  const phone = settings?.phone || "07 60 00 10 96";
  const wa = settings?.whatsapp || "33760001096";
  const waText = encodeURIComponent(`Bonjour, je viens de faire une réservation${ref ? ` (réf. ${ref})` : ""} pour un set loulav & etrog.`);

  if (!ref) {
    return (
      <div className="brand-container py-20 max-w-xl text-center">
        <h1 className="font-serif text-3xl font-bold text-brand-green mb-4">Aucune réservation trouvée</h1>
        <Link to="/commander" data-testid="restart-order" className="text-brand-green underline">Faire une réservation</Link>
      </div>
    );
  }

  return (
    <div className="brand-container py-20 max-w-xl text-center">
      <div className="animate-fade-up" data-testid="reservation-success">
        <CheckCircle2 className="w-16 h-16 text-brand-green mx-auto mb-4" />
        <h1 className="font-serif text-4xl font-bold text-brand-green mb-2">Merci {name || ""} !</h1>
        <p className="text-brand-green/80 text-lg mb-1">Votre commande a été reçue.</p>
        <p className="text-brand-green/70 mb-6">Nous revenons vers vous rapidement pour convenir du paiement et de la remise.</p>

        <div className="bg-white rounded-2xl p-6 border border-brand-green/10 shadow text-left space-y-3 mb-8">
          <div className="flex justify-between"><span className="text-brand-green/60">Référence</span><span data-testid="order-ref" className="font-semibold text-brand-green">{ref}</span></div>
          <div className="flex items-start gap-2 bg-brand-sage rounded-xl p-3 text-sm text-brand-green">
            <MapPin className="w-4 h-4 text-brand-gold mt-0.5 shrink-0" />
            Le règlement se fait en espèces ou par Revolut au moment de la remise. Nous vous appelons pour l'adresse et l'horaire.
          </div>
        </div>

        <p className="text-sm text-brand-green/60 mb-3">Une question ? Écrivez-nous directement :</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href={`https://wa.me/${wa}?text=${waText}`} target="_blank" rel="noreferrer" data-testid="thankyou-whatsapp"
            className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-white px-6 py-3 font-bold hover:opacity-90 transition-opacity shadow-lg">
            <MessageCircle className="w-5 h-5" /> WhatsApp {phone}
          </a>
          <a href={`tel:${phone.replace(/\s/g, "")}`} data-testid="thankyou-phone"
            className="inline-flex items-center gap-2 rounded-full border border-brand-green/20 text-brand-green px-6 py-3 font-semibold hover:bg-brand-green/5">
            <Phone className="w-5 h-5" /> Appeler
          </a>
        </div>

        <Link to="/" className="inline-block mt-8 text-brand-green underline">Retour à l'accueil</Link>
      </div>
    </div>
  );
}
